import React from 'react';
import _ from 'lodash';
import Button from 'components/Button';
import {
  singleProfit,
  doubleProfit as doubleProfitData,
} from 'pages/home/ProfitSection/data';
import {
  Description,
  Separator,
  Profit,
  CustomerPay,
  YouPay,
  YourProfit,
} from 'styles/pages/home/profits';

const Profits = ({ toggleSignUpDialog, doubleProfit }) => {
  const data = doubleProfit ? doubleProfitData : singleProfit;
  return (
    <Description>
      <h3>{data.title}</h3>
      <h2>{data.subTitle}</h2>
      <p>{data.description}</p>
      <Separator></Separator>
      <Profit>
        <CustomerPay>
          <p>Your customer pays you</p>
          <h5>
            ${data.customerPaysYou.dollar}.
            <sup>{data.customerPaysYou.cents}</sup>
          </h5>
        </CustomerPay>
        <YouPay>
          <p>You Pay Big Oven Tees to produce and ship</p>
          <h5>
            ${data.shirtlyPay.dollar}.<sup>{data.shirtlyPay.cents}</sup>
          </h5>
        </YouPay>
        <YourProfit>
          <p>Your profit</p>
          <h5>
            ${data.yourProfit.dollar}.<sup>{data.yourProfit.cents}</sup>
          </h5>
        </YourProfit>
        <Button
          containerStyle={{
            fontSize: '15px',
            borderRadius: '50px',
          }}
          variant='text'
          title='Make more profit'
          onClick={() =>
            _.isFunction(toggleSignUpDialog) && toggleSignUpDialog()
          }
        />
      </Profit>
    </Description>
  );
};

export default Profits;
